import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
@Injectable()
export class VersionInterceptor implements HttpInterceptor {
  
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    console.log(environment.API_VERSION)
    const modifiedRequest = request.clone({
      setHeaders: {
        'X-API-Version': environment.API_VERSION
      }
    });

    return next.handle(modifiedRequest);
  }
}
